var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("cx-vui-input", {
        attrs: {
          label: _vm.label.api_key,
          "wrapper-css": ["equalwidth"],
          description: `${_vm.help.apiPref} <a href="${_vm.help.apiLink}" target="_blank">${_vm.help.apiLinkLabel}</a>`,
          size: "fullwidth",
        },
        model: {
          value: _vm.current.api_key,
          callback: function ($$v) {
            _vm.$set(_vm.current, "api_key", $$v)
          },
          expression: "current.api_key",
        },
      }),
      _vm._v(" "),
      _c("cx-vui-switcher", {
        attrs: {
          label: _vm.label.disable_js,
          description: _vm.help.disable_js,
          "wrapper-css": ["equalwidth"],
        },
        model: {
          value: _vm.current.disable_js,
          callback: function ($$v) {
            _vm.$set(_vm.current, "disable_js", $$v)
          },
          expression: "current.disable_js",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }